import { render } from "./TransportationView.vue?vue&type=template&id=07e4d964&scoped=true"
import script from "./TransportationView.vue?vue&type=script&lang=js"
export * from "./TransportationView.vue?vue&type=script&lang=js"

import "../style/transportation.scss?vue&type=style&index=0&id=07e4d964&lang=scss&scoped=true&external"
import "../style/common.scss?vue&type=style&index=1&id=07e4d964&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e4d964"]])

export default __exports__